export const ENTER = 'Enter'
export const COMMA = ','
export const SPACE = ' '
export const DELETE = 'Backspace'
export const EMPTY = ''
